<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__links">
        <a class="footer__link" href="https://naprokat.ru/terms_and_conditions/terms_of_use" target="_blank">Пользовательское соглашение</a>
        <a class="footer__link" href="https://naprokat.ru/terms_and_conditions" target="_blank">Условия аренды</a>
      </div>
      <div class="footer__copyright">Copyright 2022 Naprokat.ru</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
